"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M15.3333 12.0153c0 .5531-.4264 1.0015-.9524 1.0015s-.9524-.4484-.9524-1.0015.4264-1.0015.9524-1.0015.9524.4484.9524 1.0015z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4649 18.775c-1.0396 1.4233-2.9114 2.1126-4.5642 1.6328C7.0522 22.3282 4.2973 22.2856 2 21.4627V6.2873C2 3.8982 3.8779 2 6.1486 2c1.0222 0 1.9618.3832 2.687 1.0207 2.506-.1178 5.0331 1.6485 5.4092 4.3605C18.2151 7.8898 22 13.4393 22 17.4246c0 1.961-1.6343 3.6076-3.5944 3.1637-1.429-.3236-3.2994-.8794-4.9407-1.8133zM3.9047 6.2873c0-1.2403.9841-2.2842 2.2439-2.2842.8564 0 1.435.4975 1.9869 1.1105 1.7419-.2334 3.8044.3518 4.2024 2.438-.3404.1047-.6846.2506-1.0312.4412-1.0942-.1282-2.1798-.4215-3.2494-.6855-.3992-.0985-1.1274-.1894-1.6382.3654-.558.606-.3607 1.4056-.1952 1.8252.4705 1.1932 1.517 3.2349 3.4337 4.2074.1926 1.6863 1.0842 2.9817 2.2137 3.9579-1.0197 1.2393-2.3496.9212-3.5412.281-1.0933 1.5663-2.5067 2.3318-4.4253 2.0152V6.2873zM8.2886 9.419c1.1412.2716 2.317.5931 3.4928.5931.9168-.5623 1.8892-.8693 2.9265-.4616 2.4703.9709 5.3875 5.2111 5.3875 7.874 0 .8345-.65 1.3502-1.2887 1.2055-3.3513-.759-7.2829-2.1532-7.2829-6.3351-1.4685-.5148-2.504-1.3982-3.2352-2.876z"
  })];
};

exports.default = _default;